import { RiDeleteBin6Line } from 'react-icons/ri';
import { FiEdit } from 'react-icons/fi';
import { SlEye } from 'react-icons/sl';

const tdClass = 'px-6 py-3';

const parseDate = (date) => {
    //format dd/mm/yyyy
    let date2 = new Date(date);
    let day = date2.getDate();
    let month = date2.getMonth() + 1;
    let year = date2.getFullYear();
    return `${day}/${month}/${year}`;
}

const ItemRow = ({ handleEdit, item, type, handleView, handleDelete, isAdmin, permissions, disabled }) => {
    console.log('item', item)

    let id, date, data, name, phone, parsedData, mail, username, requestsQuantity;
    let showView = true, showEdit = true, showDelete = true;
    if (permissions) {
        if (type === 'requests') {
            showView = permissions.requests.view;
            showEdit = permissions.requests.edit;
            showDelete = permissions.requests.delete;
        }
        if (type === 'contracts') {
            showView = permissions.contracts.view;
            showEdit = permissions.contracts.edit;
            showDelete = permissions.contracts.delete;
        }
    }

    if (disabled) {
        showView = false;
        showEdit = false;
        showDelete = false;
    }

    if (type === 'users') {
        username = item?.username;
        name = item?.name;
        phone = item?.phone;
        mail = item?.mail;
    }

    if (type === 'requests' || type === 'contracts') {
        id = item?.id;
        date = item?.date;
        data = item?.data;
        try {
            parsedData = JSON.parse(data);
        }
        catch (err) {
            console.log(err);
            parsedData = {};
        }
    }

    if (type === 'requests') {
        name = parsedData?.cabezalTitular;
        phone = parsedData?.solicitanteTel1;
    }
    if (type === 'contracts') {
        name = parsedData?.clausulaFallecido;
        phone = parsedData?.clausulaVelada;
    }
    if (type === 'report') {
        name = item?.name;
        requestsQuantity = item?.requestsQuantity;
    }

    let firstRow = type === 'users' ? username : type === 'report' ? name : id;
    let secondRow = type === 'report' ? requestsQuantity : name;

    return (
        <tr className={'rowTable'} key={id}>
            <th scope="row" className="px-6 py-3 font-medium whitespace-nowrap">{firstRow}</th>
            <td style={{ width: 250 }} className={tdClass}>{secondRow}</td>
            {type !== 'report' && <td className={tdClass}>{type !== 'users' ? parseDate(date) : mail || ''}</td>}
            {type !== 'report' && <td className={tdClass}>{phone}</td>}
            {type !== 'report' && <td className="flex gap-2 px-6 py-3 font-medium flew-row ">
                {showView && type !== 'users' && <span title="Visualizar" className="duration-300 cursor-pointer hover:text-blue-700" onClick={() => handleView(id)}><SlEye size={20} /></span>}
                {showEdit && <span title="Editar" className="duration-300 cursor-pointer hover:text-blue-700" onClick={() => handleEdit(type !== 'users' ? id : username)}><FiEdit size={20} /></span>}
                {showDelete && <span title="Eliminar" className="duration-300 cursor-pointer hover:text-blue-700" onClick={() => handleDelete(type !== 'users' ? id : username)}><RiDeleteBin6Line size={20} /></span>}
            </td>}
        </tr>
    )
}

export default ItemRow;